import { formatDistanceToNow } from 'date-fns'

export const formatMessageTime = (createdAt: string | Date, options = { short: false }) => {
  let distance = formatDistanceToNow(new Date(createdAt), { addSuffix: true }).replace('about ', '')

  if (options.short) {
    distance = distance.replace(' ago', '') // Remove 'ago'
    distance = distance.replace('less than a minute', 'now') // Convert "less than a minute" to "now"

    return distance
      .replace(' minutes', 'm')
      .replace(' minute', 'm')
      .replace(' hours', 'h')
      .replace(' hour', 'h')
      .replace(' days', 'd')
      .replace(' day', 'd')
      .replace(' months', 'mo')
      .replace(' month', 'mo')
      .replace(' years', 'y')
      .replace(' year', 'y')
  }

  return distance
}
